import React, {useEffect, useState} from 'react';
import './index.css';
import {useTranslation} from "react-i18next";
import NoData from "../../components/no-data";
import SvgIcon from "../../components/svg-icon";
import {useSelector} from "react-redux";
import associateServices from "../../services";
import InstrumentIcon from "../../components/instrument-icon";
import {Tooltip} from "react-tooltip";
import Big from "big.js";
import {decrypt, encrypt} from "../../helpers/encryption";
import {LazyLoadImage} from "react-lazy-load-image-component";
import Loading from "../../components/loading";
import {Link} from "react-router-dom";
import ChallengeList from "./list";

const types = ['all', 'active', 'all-claimed'];

const Challenges = () => {
    const {t} = useTranslation()
    const {selectedWallet} = useSelector(state => state.authenticationReducer)
    const [loading, setLoading] = useState(true)
    const [activeType, setActiveType] = useState('all')
    const [challenges, setChallenges] = useState([])

    useEffect(() => {

        setLoading(true)
        associateServices.getChallenges({type: activeType}).then(res => {
            setChallenges(res?.data)
            setLoading(false)

        })
    }, [activeType])

    const [rates, setRates] = useState({})

    const getAmountInConversion = amount => {
        if (!selectedWallet?.code)
            return ''

        if (selectedWallet?.code === 'USDT' || selectedWallet?.code === 'USDC')
            return Big(amount || 0).toFixed(2)

        return Big(amount || 0).times(rates[selectedWallet?.code] || 0).toFixed(['TRY', 'USD', 'USDT'].includes(selectedWallet?.code) ? 2 : 5)
    }

    useEffect(() => {
        const handleFiatRates = e => {
            const data = decrypt(e)
            setRates(data)
        }
        window?.tcpSocket?.emit('fiat:rate', encrypt({
            currency: 'USD'
        }))

        window?.tcpSocket?.on('fiat:rates', handleFiatRates)
    }, [])

    return (
        <div className="section">

            <div className="container">
                <div className="row">

                    <div className="col-12 d-flex justify-content-between align-items-center">
                        <h1 className="section__title section__title--head">{t('challenges.title')}</h1>

                        <ul
                            className="nav nav-tabs tabs-nav"
                            id="tabs-nav"
                            role="tablist"
                        >

                            {
                                types?.map(type => (
                                    <li className="nav-item" role="presentation" key={type}>
                                        <button
                                            onClick={e => setActiveType(type)}
                                            className={`tabs-nav__btn ${activeType === type ? 'active' : ''}`}
                                            type="button">
                                            {t(`challenges.${type}`)}
                                        </button>
                                    </li>
                                ))
                            }

                        </ul>
                    </div>



                    <ChallengeList challenges={challenges} loading={loading}/>


                </div>
            </div>
        </div>

    );
};

export default Challenges;
